module.exports = __webpack_public_path__ + "img/ic_close_larger.def2d781.svg";